import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { truncateMiddle } from "../format.js";
import { cn } from "./cn.js";
import { CopyButton } from "./CopyButton.js";
/**
 * A long address or hash, truncated in the middle ("0x12ab…9f3c"). Tap/click shows the full value,
 * hovering shows it as a tooltip, and the copy button always copies the full value.
 */
export function Address({ value, start = 6, end = 4, copy = true, className, }) {
    const [expanded, setExpanded] = useState(false);
    return (_jsxs("span", { className: cn("inline-flex max-w-full min-w-0 items-center gap-1", className), children: [_jsx("button", { type: "button", onClick: () => setExpanded((v) => !v), title: value, "aria-expanded": expanded, "aria-label": expanded ? value : `${truncateMiddle(value, start, end)} (show full)`, className: cn("min-w-0 rounded px-0.5 text-left font-mono text-sm text-fg hover:bg-hover", expanded ? "break-all" : "truncate"), "data-full": value, children: expanded ? value : truncateMiddle(value, start, end) }), copy && _jsx(CopyButton, { value: value, label: "Copy address" })] }));
}
//# sourceMappingURL=Address.js.map